'use client'

import { Query, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { memo, PropsWithChildren, useState } from 'react'

import { isForbiddenError } from '@api/httpStatus'
// For devtools:
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

export const queryDefaults = {
  staleTime: 60_000, // fresh for 60s => no refetch on next page
  gcTime: 5 * 60_000, // keep in memory 5m
  refetchOnWindowFocus: false,
  retry: false,
  // A 403 is final for the session's keys. Re-running it on every mount loops when a page swaps its
  // content for a spinner while that query is pending. `invalidateQueries` still refetches it.
  retryOnMount: (query: Query) => !isForbiddenError(query.state.error),
}

export const qc = new QueryClient({
  defaultOptions: {
    queries: queryDefaults,
    mutations: {
      retry: false, // optional: disables retries for mutations
    },
  },
})

export const TSQueryProvider = memo(({ children }: PropsWithChildren) => {
  // Important: keep QueryClient across page changes
  const [client] = useState(qc)

  return (
    <QueryClientProvider client={client}>
      {children}
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  )
})
